import React, { Fragment, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Typography from '@material-ui/core/Typography';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: 'red',
    padding: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paidContainer: {
    backgroundColor: theme.palette.primary.main,
  },
  text: {
    color: '#FFFFFF',
    fontSize: 14,
    fontWeight: 500,
    '&& a': {
      color: 'inherit',
    },
  },
  icon: {
    color: '#FFFFFF',
    fontSize: 16,
    marginRight: 6,
  },
}));

export const Description = ({ status, subscriptionType, dueDate }) => {
  switch (status) {
    case 'trial':
      if (subscriptionType === 'individual') {
        return `This is a trial, it will end on ${dueDate}.`;
      }

      if (subscriptionType === 'stripe_based_started') {
        return 'Thank you! We’ll make the first charge to your card after your trial ends.';
      }

      return (
        <Fragment>
          {`This is a trial, it will end on ${dueDate}. Please update your payment method `}
          <Link to="/subscription">here</Link>.
        </Fragment>
      );

    case 'waiting_for_payment':
      return 'We are waiting for payment, the system will still work until we receive payment from your payment provider.';

    case 'expiring':
      return 'It looks like something is wrong with your payment method. Please contact us.';

    case 'inactive':
      return 'Your account is disabled. Please update your payment method and stay compliant.';

    case 'active':
    default:
      return '';
  }
};

export const PaymentBanner = ({
  status,
  subscriptionType,
  trialOrActivePeriodEnds,
  onVisibleStateChange,
  paymentMethod,
}) => {
  const paymentMethodsToIgnore = ['external', 'manual_stripe'];
  const isPaymentMethodToIgnore = paymentMethodsToIgnore.includes(paymentMethod);

  const classes = useStyles();
  const isVisible = isPaymentMethodToIgnore ? false : status !== 'active';
  const isSubscriptionStarted = subscriptionType === 'stripe_based_started';
  const dueDate = moment(trialOrActivePeriodEnds).format('Do MMMM YYYY');

  useEffect(() => {
    onVisibleStateChange(isVisible);
  }, [status, subscriptionType]);

  if (!isVisible || isPaymentMethodToIgnore) {
    return null;
  }

  return (
    <div className={`${classes.container} ${isVisible && isSubscriptionStarted && classes.paidContainer}`}>
      <SvgIcon className={classes.icon}>
        <path
          xmlns="http://www.w3.org/2000/svg"
          /* eslint-disable-next-line max-len */
          d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
        />
      </SvgIcon>
      <Typography className={classes.text}>
        <Description
          status={status}
          subscriptionType={subscriptionType}
          dueDate={dueDate}
          paymentMethod={paymentMethod}
        />
      </Typography>
    </div>
  );
};
